import * as zxcvbn from 'zxcvbn';

export const getPasswordStrength = (password: string | undefined) => {
  if (!password) return '';
  const { score } = zxcvbn.default(password);
  switch (score) {
    case 0:
      return 'Very Weak';
    case 1:
      return 'Weak';
    case 2:
      return 'OK';
    case 3:
      return 'Good';
    case 4:
      return 'Strong';
  }
};
